module.exports = __webpack_public_path__ + "img/STEP1.663303bd.png";